import { FETCH_STORE_INVENTORY } from "../../constants/action.constants";

const initialState = {
  list: [],
  others: {},
};

const storeInventoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_STORE_INVENTORY:
      return { list: action.payload, others: action.others };
    default:
      return state;
  }
};

export default storeInventoryReducer;
